
<mat-form-field appearance="legacy" floatLabel="never" class="p-0 m-0" style="display: flex; flex-direction: row; align-content: center;">
  <mat-icon matPrefix class="mr-2 p-0" style="height:40px;width:40px; display: flex; align-items: center;justify-content: center; margin-top:0;" >search</mat-icon>
  <input matInput [placeholder]="placeHolder" autocomplete="off"
         style="flex: 1 1 auto;"
         class="m-0 p-0"
         [formControl]="txtSearchBox"
         name="searchQuery">
</mat-form-field>
